import React, { Component } from 'react';
import { Div, Text } from '@pinpoint/design-kit';

import { insights } from 'src/components';

/* eslint-disable react/prop-types */

const HIDE_INSIGHTS = true;

export default class TextualContent extends Component {
	constructor(props) {
		super(props);
		const { eventEmitter } = this.props;
		this.state = {
			selectedTrait: props.selectedTrait,
			selectedScore: props.selectedScore,
		};
		eventEmitter.subscribe('scoreChanged', (score) => {
			this.setState({
				selectedScore: score,
			});
		});
		eventEmitter.subscribe('traitChanged', (trait) => {
			this.setState({
				selectedTrait: trait,
			});
		});
	}

	render() {
		const {
			selectedTrait: { code, subType, trait, highRangeName, lowRangeName, description, factor },
			selectedScore,
		} = this.state;
		const { styleOverride } = this.props;
		let range;
		if (selectedScore < 10) range = 'Extremely Low';
		else if (selectedScore < 30) range = 'Very Low';
		else if (selectedScore < 45) range = 'Low';
		else if (selectedScore < 55) range = 'Neutral';
		else if (selectedScore < 70) range = 'High';
		else if (selectedScore < 90) range = 'Very High';
		else range = 'Extremely High';
		const type = selectedScore > 50 ? 'high' : 'low';
		return (
			<Div d="flex" flexDir="column" justify="start" h="100%" style={styleOverride}>
				<Div
					d="flex"
					justify={{ xs: 'center', md: 'space-between' }}
					flexDir={{ xs: 'column', md: 'row' }}
					align={{ xs: 'center', md: 'start' }}
					m={{ b: '1rem' }}
				>
					<Div>
						<Div>
							{subType === 'factor' ? (
								<Div d="flex" justify={{ xs: 'center', md: 'start' }} p={{ b: '0.5rem' }}>
									<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="tabSelected" tag="span">
										{`${subType.charAt(0).toUpperCase() + subType.slice(1)}:`}&nbsp;
									</Text>
									<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="brand500" tag="span">
										{trait}
									</Text>
								</Div>
							) : (
								<Div
									d="flex"
									flexDir={{ xs: 'column', md: 'row' }}
									justify={{ xs: 'center', md: 'start' }}
									align="center"
									p={{ b: '0.5rem' }}
								>
									<Div d="flex" justify={{ xs: 'center', md: 'start' }}>
										<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="tabSelected" tag="span">
											Factor:&nbsp;
										</Text>
										<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="brand500" tag="span">
											{factor}
										</Text>
										<Text textSize="title" textWeight="400" tag="span" d={{ xs: 'none', md: 'block' }}>
											&nbsp; / &nbsp;
										</Text>
									</Div>
									<Div d="flex" justify={{ xs: 'center', md: 'start' }}>
										<Text fontFamily="secondary" textSize="title" textWeight="400" tag="span" textColor="tabSelected">
											Facet:&nbsp;
										</Text>
										<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="brand500" tag="span">
											{trait}
										</Text>
									</Div>
								</Div>
							)}
						</Div>
						<Div
							d="flex"
							flexDir={{ xs: 'column', md: 'row' }}
							justify={{ xs: 'center', md: 'start' }}
							align="center"
							p={{ t: '0.5rem' }}
						>
							<Text fontFamily="secondary" textSize="title" textWeight="400" tag="span" textColor="tabSelected">
								Range:&nbsp;
							</Text>
							<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="brand500" tag="span">
								{selectedScore > 50 ? highRangeName : lowRangeName}
							</Text>
						</Div>
					</Div>
					<Div>
						<Text fontFamily="secondary" textSize="title" textWeight="400" tag="span" textColor="tabSelected">
							Score:&nbsp;
						</Text>
						<Text fontFamily="secondary" textSize="title" textWeight="400" textColor="brand500" tag="span">
							{`${range} (${selectedScore.toFixed(1)})`}
						</Text>
					</Div>
				</Div>
				<Div m={{ b: '0.25rem' }}>
					<Text textSize="subheader" textColor="tabSelected">
						{description}
					</Text>
				</Div>
				{!HIDE_INSIGHTS ? (
					<Div m={{ b: '0.25rem' }}>
						<Text
							textSize="body"
							textColor="brand500"
							dangerouslySetInnerHTML={{
								__html: selectedScore === 50 ? 'This factor/facet is not actionable' : insights[code][type],
							}}
						/>
					</Div>
				) : null}
			</Div>
		);
	}
}
